import './PageModePanelBattle.scss';
import './Drawer.scss';
import Control from "../../../1. Core/Control";
import NP, {EventArgs} from "../../../1. Core/NP";
import ListBox, {ListBoxItemArgs} from "../../../1. Core/Controls/ListBox/ListBox";
import Delegate from "../../../1. Core/Delegate";
import AccountPanelBattle from "../Panels/AccountPanel/AccountPanelBattle";
import {PageMode, SportType} from "../../types";
import {getCurrentUser, signOut} from "../../../1. Core/UserInfo";
import Accordion from "../../../1. Core/Controls/Accordion/Accordion";


export default class PageModePanelBattle extends Control {
	private _AccountPanel: AccountPanelBattle;
	private _navList: ListBox;

	private EvTeamSelected: Delegate;
	private EvItemSelected: Delegate;
	private _signOutlist: ListBox;
	private _navSelect: Accordion;
	private _adminNav: Accordion;


	constructor(settings: object)
	{
		super(settings);
		this._render();
		this.refresh();
	}

	_initFields(settings: object)
	{
		this.EvItemSelected = new Delegate();
		this.EvTeamSelected = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render('<aside class="drawer battle-page-mode-panel">' +
			 '<div class="drawer__content">' +
			 '<div class="battle-page-mode-panel__header"></div>' +
			 '</div>' +
			 '</aside>'
		);

		this.setTabIndex(1);

		this._AccountPanel = new AccountPanelBattle({
			ParentNode: this._root.querySelector('.battle-page-mode-panel__header')
		});

		let listParent = this._root.querySelector('.drawer__content');


		this._navSelect = new Accordion({
			ParentNode: listParent,
			Class: 'nav-select',
			AutoCollapse: false,
			Items: [{
				HeaderText: 'MMA',
				Content: new ListBox({
					EvItemSelected: (s: object, e: ListBoxItemArgs) => this.onSelectedItem(e),
					Items: [{
						RK: 'MMA Athletes',
						FontImage: NP.FontImages.supervisor_account_tt,
						Value: PageMode.mmaathletes,
						Data: SportType.MMA
					}, {
						RK: "Bouts",
						FontImage: NP.FontImages.fight_tt,
						Value: PageMode.mmaresults,
						Data: SportType.MMA
					}, {
						RK: 'Events',
						FontImage: NP.FontImages.event,
						Value: PageMode.mmaevents,
						Data: SportType.MMA
					}, {
						RK: 'MMARating',
						FontImage: NP.FontImages.column,
						Value: PageMode.mmarating,
						Data: SportType.MMA
					}, {
						RK: 'Refereeing',
						FontImage: NP.FontImages.star_tt,
						Value: PageMode.mmarefereeing
					}, {
						Content: 'Highlights',
						FontImage: NP.FontImages.fight_tt,
						Value: PageMode.mmahighlights
					}, {
						RK: 'Trainers',
						FontImage: NP.FontImages.supervisor_account_tt,
						Value: PageMode.trainers
					},{
						RK: "States",
						FontImage: NP.FontImages.geo_tt,
						Value: PageMode.mmastates
					}]
				}),
				Value: SportType.MMA
			}, {
				HeaderText: 'Kickboxing',
				Value: SportType.KB,
				Content: new ListBox({
					EvItemSelected: (s: object, e: ListBoxItemArgs) => this.onSelectedItem(e),
					Items: [
						{
							RK: 'KickBoxers',
							FontImage: NP.FontImages.supervisor_account_tt,
							Value: PageMode.kickboxers
						}, {
							RK: 'Bouts',
							FontImage: NP.FontImages.fight_tt,
							Value: PageMode.kbbouts
						}, {
							RK: 'Events',
							FontImage: NP.FontImages.event,
							Value: PageMode.kbevents
						}, {
							Content: 'Highlights',
							FontImage: NP.FontImages.fight_tt,
							Value: PageMode.kbhighlights
						}
					]
				})
			}, {
				HeaderText: 'Boxing',
				Content: new ListBox({
					EvItemSelected: (s: object, e: ListBoxItemArgs) => this.onSelectedItem(e),
					Items: [{
						RK: 'Boxers',
						FontImage: NP.FontImages.supervisor_account_tt,
						Value: PageMode.boxers
					}, {
						RK: "Bouts",
						FontImage: NP.FontImages.fight_tt,
						Value: PageMode.boxresults
					}, {
						RK: 'Events',
						FontImage: NP.FontImages.event,
						Value: PageMode.boxevents
					}, {
						RK: "States",
						FontImage: NP.FontImages.geo_tt,
						Value: PageMode.states
					}, {
						RK: 'Refereeing',
						FontImage: NP.FontImages.star_tt,
						Value: PageMode.boxrefereeing
					}]
				}),
				Value: SportType.Box
			}],
		})

		this._navList = new ListBox({
			ParentNode: listParent,
			Items: [{
				IsSeparator: true,
				Value: 'FSep'
			}, {
				Content: 'Bookmakers',
				FontImage: NP.FontImages.apps,
				Value: PageMode.bookmaker
			}, {
				Content: 'Widget Store',
				FontImage: NP.FontImages.apps,
				Value: PageMode.widgets
			}, {
				Content: 'Fantasy',
				FontImage: NP.FontImages.fight_tt,
				Value: PageMode.fantasy
			}, {
				Content: 'Cards',
				FontImage: NP.FontImages.file,
				Value: PageMode.cardsfantasy
			}, {
				Content: 'News',
				FontImage: NP.FontImages.file,
				Value: PageMode.newssource
			}, {
				Content: 'Videos',
				FontImage: NP.FontImages.file,
				Value: PageMode.videosource
			}, {
				Content: 'Promocodes',
				FontImage: NP.FontImages.file,
				Value: PageMode.promocodes
			}],
			EvItemSelected: (s: object, e: ListBoxItemArgs) => this.onSelectedItem(e)
		});


		let user = getCurrentUser()
		if (!user.getIsAdmin())
		{

			this._navSelect.getItems().forEach(accItem =>
			{
				let vis = this.filterListByFeatures(accItem.getContent() as ListBox)
				if (!vis)
					accItem.setIsVisible(false)
			})

			this.filterListByFeatures(this._navList)
		}
		else
			this._adminNav = new Accordion({
				ParentNode: listParent,
				Items: [{
					HeaderText: NP.RM.getString('Settings'),
					Content: new ListBox({
						ParentNode: listParent,
						Items: [{
							RK: 'Tournaments',
							FontImage: NP.FontImages.fight_tt,
							Value: PageMode.tournaments
						}, {
							RK: 'Users',
							FontImage: NP.FontImages.supervisor_account_tt,
							Value: PageMode.users
						}, {
							Content: 'Players',
							FontImage: NP.FontImages.supervisor_account_tt,
							Value: PageMode.players
						}, {
							Content: 'Push Schedule',
							FontImage: NP.FontImages.supervisor_account_tt,
							Value: PageMode.push
						}],
						EvItemSelected: (s: object, e: ListBoxItemArgs) => this.onSelectedItem(e)
					})
				}]
			})


		this._signOutlist = new ListBox({
			ParentNode: listParent,
			Items: [{
				IsSeparator: true
			}, {
				RK: 'SignOut',
				FontImage: NP.FontImages.exit_to_app,
				EvClick: () => signOut()
			}]
		});

		this.setWidth();
	}

	filterListByFeatures(list: ListBox)
	{
		let user = getCurrentUser();
		let hasNavVis = false;
		list.getItems().forEach(item =>
		{
			if (user.getFeatures().find(f => f == item.getValue()))
				hasNavVis = true;
			else
				item.setIsVisible(false)
		});

		if (hasNavVis)
			return true;
		else
			list.setIsVisible(false)
	}

	onSelectedItem(e: ListBoxItemArgs)
	{
		this.modalClose()
		this.clearSelection(e.Item.getValue())
		this.EvItemSelected.fire(this, {PageMode: e.Item.getValue()})
	}

	clearSelection(newValue: string)
	{
		let lists = [
			this._adminNav ? this._adminNav.getItems()[0].getContent() as ListBox : null,
			this._navList,
			...(this._navSelect.getItems().map(accItem => accItem.getContent() as ListBox))
		]


		lists.forEach(lsit =>
		{
			if (lsit && !lsit.getItem(newValue))
				lsit.clearSelection()
		})
	}

	selectPageMode(pageMode: PageMode)
	{
		let lists = [this._navList, ...this._navSelect.getItems().map(accItem => accItem.getContent() as ListBox)];
		lists.forEach(list =>
		{
			if (list.getItem(pageMode))
				list.setValue(pageMode, false)
			else
				list.clearSelection();
		})
	}

	setValue(value: string, fireEvent?: boolean)
	{
		if (this._navList.getItem(value))
		{
			this._navList.setValue(value, fireEvent);
		}
	}

	refresh()
	{
		this._AccountPanel.refresh();

		this._navSelect.getItems().forEach(item => item.open(false))
	}


	adaptiveHide()
	{
		this.addClass('mdc-drawer--modal');
	}

	adaptiveShow()
	{
		this.removeClass('mdc-drawer--modal mdc-drawer--open');
	}

	modalOpenOrHide()
	{
		if (this.hasClass('battle-page-mode-panel--visible'))
			this.modalClose();
		else
			this.modalOpen();
	}

	modalOpen()
	{
		this.addClass('battle-page-mode-panel--visible');
		setTimeout(() => this._root.focus(), 10);
	}

	modalClose()
	{
		this.removeClass('battle-page-mode-panel--visible');
	}

	_onClicked(s: Control, e: EventArgs)
	{
		e.Event.preventDefault();
		e.Event.stopPropagation();
	}
}
